module.exports = __webpack_public_path__ + "static/media/tk.44874390.svg";